import React from "react";
import { Modal } from "react-bootstrap";

const ModalAlerta = ({ modalAlerta, mostrarAlerta, mensajeAlerta, modalAlertaOficina, mostrarAlertaOficina, mensajeAlertaOficina }) => {
    return (
        <Modal
            show={modalAlerta || modalAlertaOficina}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body
                style={{ background: '#F5C618', color: '#FFFFFF' }}
                className="d-flex justify-content-center align-items-center"
            >
                {modalAlertaOficina && mostrarAlertaOficina ? (
                    <div>
                        <h5>{mensajeAlertaOficina}</h5>
                    </div>
                ) : (
                    modalAlerta && mostrarAlerta && (
                        <div>
                            <h5>{mensajeAlerta}</h5>
                        </div>
                    )
                )}
            </Modal.Body>
        </Modal>
    );
}

export default ModalAlerta;